import Loading from '/src/components/Loading.vue'
import Card from '/src/components/Card.vue'
import FButton from '/src/components/FButton.vue'
import ButtonGroup from '/src/components/ButtonGroup.vue'
import Modal from '/src/components/Modal.vue'
import Divider from '/src/components/Divider.vue'
import FullscreenModal from '/src/components/FullscreenModal.vue'
import AppLayout from '/src/layouts/AppLayout.vue'
import ModalHeader from '/src/components/ModalHeader.vue'
import AppBody from '/src/components/layout/AppBody.vue'
import AppHeader from '/src/components/layout/AppHeader.vue'
import AppScreen from '/src/components/layout/AppScreen.vue'
import AppFooter from '/src/components/layout/AppFooter.vue'
import FDialog from '/src/components/FDialog.vue'
import Panel from '/src/components/Panel.vue'


export default function ({ app }) {
  app.component('f-loading', Loading)
  app.component('f-card', Card)
  app.component('f-panel', Panel)
  app.component('f-button', FButton)
  app.component('f-button-group', ButtonGroup)
  app.component('f-modal', Modal)
  app.component('f-dialog', FDialog)
  app.component('f-divider', Divider)
  app.component('f-fullscreen-modal', FullscreenModal)
  app.component('f-app-screen', AppScreen)
  app.component('f-app-header', AppHeader)
  app.component('f-app-body', AppBody)
  app.component('f-app-footer', AppFooter)
  app.component('f-app-layout', AppLayout)
  app.component('f-modal-header', ModalHeader)
}
